'use client'

import type { HTMLAttributes } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { cx } from 'class-variance-authority'

type SortableItemProps = {
  id: string
  children: React.ReactNode
  className?: string
  disabled?: boolean
  anchor?: React.ReactNode
  onClick?: HTMLAttributes<HTMLDivElement>['onClick']
  'aria-disabled'?: HTMLAttributes<HTMLDivElement>['aria-disabled']
}

export const SortableItem = ({
  id,
  children,
  className,
  disabled,
  anchor,
  onClick,
  'aria-disabled': ariaDisabled,
}: SortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id, disabled })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const isClickDisabled =
    disabled === true || ariaDisabled === true || ariaDisabled === 'true'

  const handleClick: HTMLAttributes<HTMLDivElement>['onClick'] = (event) => {
    if (isClickDisabled) return
    onClick?.(event)
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cx('relative', className)}
      {...attributes}
      {...(!(anchor ?? disabled) && { ...listeners })}
      onClick={handleClick}
      aria-disabled={ariaDisabled}
    >
      {children}
      {anchor && !disabled && <div {...listeners}>{anchor}</div>}
    </div>
  )
}
